
const errorHandler = (err, enqueueSnackbar) => {

    switch (err.response.status) {
        case 401:
            enqueueSnackbar('Authorization failed, retrying...', {variant: "warning"});
            break;
        case 422:
            enqueueSnackbar('Couldn\'t retrieve data, please try again.', {variant: "warning"});
            break;
        default:
            enqueueSnackbar('An error has occured, please try again.', {variant: "error"});
    }
    console.log(err.response.status)
}

export default errorHandler;